import * as React from 'react';
import { ReactElement } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Heading, Loader } from 'idsk-react-components';
import routes from '../../routing/routes';
import NavrhAktuEuList from '../../module/NavrhAktuEuList';
import useFilterFromUrl from '../../module/NavrhAktuEuList/hooks/useNavrhAktuFilterFromUrl';
import GlobalErrors from '../../module/GlobalErrors';
import { Layout } from '../index';

const NavrhAktuEuListPage = (): ReactElement => {
  const {
    initialFilter,
    initialFilterLoading,
  } = useFilterFromUrl();

  return (
    <Layout>
      <Breadcrumbs
        routeList={[
          homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
          {
            to: routes.navrhyAktovEu.list.to,
            heading: routes.navrhyAktovEu.list.name,
          }]}
      />
      <GlobalErrors />
      <Heading size="xl">Návrhy aktov EÚ</Heading>
      <Loader loading={initialFilterLoading}>
        <>
          {initialFilter && !initialFilterLoading && (
            <NavrhAktuEuList initialFilter={initialFilter} />
          )}
        </>
      </Loader>
    </Layout>
  );
};
export default NavrhAktuEuListPage;
